<template lang="pug">
    div 
        loading-dialog(dialog :loading="loading")
        
        div
            v-stepper(v-model="step")
                v-stepper-header
                    v-stepper-step(
                        :complete="step > 1"
                        step="1"
                        :color="step > 1 ? 'green' : 'primary'"
                        ) Info. General
                    v-divider
                    v-stepper-step(
                        :complete="step > 2"
                        step="2"
                        :color="step > 2 ? 'green' : 'primary'"
                        ) Info. Comercial
                    v-divider
                    v-stepper-step(
                        :complete="step > 3"
                        step="3"
                        :color="step > 3 ? 'green' : 'primary'"
                        ) Info. Descuentos por cantidad.
                    v-divider
                    v-stepper-step(
                        :complete="step > 4"
                        step="4"
                        :color="step > 4 ? 'green' : 'primary'"
                        ) Info. Inventario
                v-stepper-items
                    v-stepper-content(step="1")
                        v-card
                            v-toolbar(
                                v-if="c_showButtonUpcCode"
                                dark
                                color='white' 
                                flat
                                )
                                v-spacer
                                v-btn(color="info" @click="generateUpc")
                                    | Generar UPC
                                    v-icon(right dark) refresh
                            commercial-info-step(
                                :editable="$can('EDIT_PRODUCT_ITEM')"
                                :readOnly="!$can('EDIT_PRODUCT_ITEM')"
                                title="Información General"
                                step="2"
                                v-model="item" 
                                :fields="gFields"
                                @form:submit="updateItem(item,gFields)"
                                @loading="loading = $event"
                                confirmText="Guardar Cambios"
                                nextButton="Info Comercial"
                                @step:next="step = 2"
                                ref="generalStep"
                                @editForm="listenGs"
                                )
                    v-stepper-content(step="2")
                        v-card
                            //- commercial-info-step(
                            //-     editable
                            //-     title="Información Comercial"
                            //-     v-model="item.branch_office_data[0]" 
                            //-     :fields="cFields"
                            //-     @fields:change="cFields = $event"
                            //-     @form:submit="updateItem(item, cFields)"
                            //-     @step:prev="step = 1"
                            //-     @step:next="step = 3"
                            //-     @loading="loading = $event"
                            //-     @form:reset="item.branch_office_data[0].g_branch_office_id = activeOfficeID"
                            //-     confirmText="Guardar"
                            //-     nextButton="Omitir"
                            //-     )
                            
                            commercial-info-step(
                                editable
                                title="Información Comercial"
                                v-model="item.branch_offices[0]"
                                :fields="cFields"
                                @fields:change="cFields = $event"
                                @form:submit="updateComercialItem(item, cFields)"
                                @step:prev="step = 1"
                                @step:next="step = 3"
                                @loading="loading = $event"
                                @form:reset="item.branch_office_data[0].g_branch_office_id = activeOfficeID"
                                confirmText="Guardar"
                                nextButton="Info Descuentos por cantidad"
                                ref="commercialStep"
                                prevButton="Info General"
                                )
                                template(slot="prependContent")
                                        .section.mt-4.mx-5.pl-5.mb-5
                                            h2.title Información Sucursal 
                                            v-divider.mx-3
                                        v-autocomplete.mt-4.mr-4.ml-5.px-5(
                                                outline
                                                :items="officeList"
                                                item-text="name"
                                                item-value="id"
                                                label="Sucursal"
                                                v-model="officeId"
                                                style="margin-bottom: -25px;"
                                                )
                                            template(slot="prepend")
                                                span.ml-3.formLabel Sucursal
                            
                    v-stepper-content(step="3")
                        v-card
                            commercial-info-step(
                                
                                title="Descuento Cantidad"
                                @form:submit="submitFormSaleDiscount"
                                @step:prev="step = 2"
                                @step:next="step = 4"
                                @loading="loading = $event"
                                nextButton="Info Inventario"
                                confirmText="Guardar"
                                ref="esquemaStep"
                            )
                                template(slot="prependContent").section.mt-4.mx-5.pl-5.mb-5
                                    h2.title Información Descuento Cantidad
                                    v-autocomplete.mt-4.mr-4.ml-5.px-5(
                                                outline
                                                :items="officeList"
                                                item-text="name"
                                                item-value="id"
                                                label="sucursal"
                                                v-model="officeIdSchema"
                                                style="margin-bottom: -25px;"
                                                )
                                    manage-whole-sale-discounts(
                                        crudOption="show-edit"
                                        submitText="Editar esquema" 
                                        @clear-form="clearForm"
                                        @submit-form="submitFormSaleDiscount"
                                        @cancel-editing="returnPreviousRoute"
                                        
                                    )                
                    v-stepper-content(step="4")
                        v-card
                            commercial-info-step(
                                editable
                                title="Información Inventario"
                                v-model="item" 
                                @input="test($event)"
                                :fields="iFields"
                                @fields:change="iFields = $event"
                                @form:submit="updateInventoryItem(item, iFields)"
                                @step:prev="step = 3"
                                @loading="loading = $event"
                                @step:finish="$router.push('/products')"
                                confirmText="Guardar"
                                
                                finishButton="Ir a listado de productos"
                                ref="InventoryStep"
                                prevButton="Info Descuentos"
                                )
                                    template(slot="prependContent")
                                        .section.mt-4.mx-5.pl-5.mb-5
                                            h2.title Información Sucursal 
                                            v-divider.mx-3
                                        v-autocomplete.mt-4.mr-4.ml-5.px-5(
                                                outline
                                                :items="officeList"
                                                item-text="name"
                                                item-value="id"
                                                label="sucursal"
                                                v-model="officeFormInventarioId"
                                                style="margin-bottom: -25px;"
                                                )
                                            template(slot="prepend")
                                                span.ml-3.formLabel Sucursal
          
</template>

<script>
import { CommercialInfoStep, getFormatPartialData } from './steps'
import { fieldsGeneral, fieldsComercial, fieldsInventory } from './tabs'
import { LoadingDialog } from '@/components/reusable_components'
/* vuex */
import { mapState, mapActions } from 'vuex'
/* services */
import FamilyService from '@/services/api/family/FamilyServices'
import BranchOfficeService from '@/services/api/branchOffice'
import ProductService from '@/services/api/product'
import TagService from '../../services/api/tag/TagServices'
import SubfamilyService from '@/services/api/subfamily/SubfamilyService'
import UPCService from '@/services/api/upc'
import MeasurementUnitService from '@/services/api/unitMeasurement/UnitMeasurementService'
/* others */
import SaleUtils from '@/services/SaleUtils.js'
//
import ManagerWholesaleDiscounts from '@/components/WholesaleDiscount/Manager'
import priceSchemeProduct from '../../services/api/priceScheme/updatePriceSchemeProduct.js'
import getPriceSchemeProduct from '../../services/api/priceScheme/getPriceSchemeProduct.js'
export default {
    name: 'show-edit-tab',
    props: {},
    data: function() {
        return {
            step: 1,
            loading: true,
            item: {},
            _gFields: [],
            gFields: [...fieldsGeneral],
            cFields: fieldsComercial,
            iFields: fieldsInventory,
            activeOfficeID: 1,
            officeList: [],
            showButtonUpcCode: false,
            officeId: null,
            officeFormInventarioId: null,
            officeIdSchema:null,
            schemaDiscountProducts:null,
        }
    },
    computed: {
        c_showButtonUpcCode: {
            get: function() {
                return this.showButtonUpcCode
            },
            set: function(val) {
                this.showButtonUpcCode = val
            },
        },
        ...mapState('AuthModule', {
            user: 'user',
        }),
        ...mapState('WholesaleDiscountModule', {
            arrayDiscounts: 'arrayDiscounts',
            id: 'id',
            globalPercentageDiscount: 'globalPercentageDiscount',
        }),
    },
    methods: {
        /**
         *
         */
        formatPartialData: getFormatPartialData(this),
        /**
         *
         */
        updateItem: async function(item = this.item, fields, parse = false) {
            this.item.upc_codes = this.$refs.generalStep.$refs.stepForm.vmodels.upc_codes.flat()
            this.item.tags = this.$refs.generalStep.$refs.stepForm.vmodels.tags
            let data = parse ? this.getPropsByFields(item, fields) : item
            data = this.formatBranchOffice(data)
            data = this.formatPartialData(data)
            data = this.formatTags(data)

            this.loading = true
            let response = await ProductService.updateItem(item.id, data)

            if (this.responseMessage(response)) {
                this.$refs.generalStep.$refs.stepForm.editSwitch = false //luego de actualizar se vuelve a switch false
            }
            this.loading = false
            return
        },
        responseMessage(response) {
            if (![200, 201, 'success'].includes(response.status)) {
                let message = response.data.errors
                    ? response.data.errors
                    : response.data.message
                this.showSnackbar('error', 'Error al guardar', message)
                this.loading = false
                return false
            }
            this.showSnackbar(
                'success',
                'Éxito',
                'Información Actualizada Exitosamente'
            )
            return true
        },
        /**
         *
         */
        async updateComercialItem(item = this.item, fields) {
            //
            this.item.branch_office_data = this.getBranchOfficeData()
            this.item.is_consumable = this.$refs.commercialStep.$refs.stepForm.vmodels.is_consumable
            this.item.is_salable = this.$refs.commercialStep.$refs.stepForm.vmodels.is_salable
            this.item.is_tax_free = this.$refs.commercialStep.$refs.stepForm.vmodels.is_tax_free
            /* this items really can be updated in step 3 */
            this.item.uom_quantity = this.item.wh_item.uom_quantity
            this.item.wh_unit_of_measurement_id = this.item.wh_item.wh_unit_of_measurement_id
            this.item.is_inventoriable = this.item.wh_item.is_inventoriable
            this.item.have_decimal_quantity = this.item.wh_item.have_decimal_quantity
            this.item.warranty_days = this.item.branch_office_data[0].warranty_days
            /* end  item step 3 */
            let dataForSending = this.item
            let response = await ProductService.updateItem(
                this.item.id,
                dataForSending
            )
            if (this.responseMessage(response)) {
                this.$refs.commercialStep.$refs.stepForm.editSwitch = false //luego de actualizar se vuelve a switch false
            }
        },
        /**
         *
         */
        getBranchOfficeData() {
            let branch_office_data = []
            let dataBranch = {}
            dataBranch.g_branch_office_id = this.officeId //current branch
            /* step 2 data */
            dataBranch.cost_price = this.$refs.commercialStep.$refs.stepForm.vmodels.cost_price
            dataBranch.sale_price = this.$refs.commercialStep.$refs.stepForm.vmodels.sale_price
            dataBranch.warranty_days = this.$refs.commercialStep.$refs.stepForm.vmodels.warranty_days
            dataBranch.gains_margin = parseInt(
                SaleUtils.getMargin(
                    dataBranch.sale_price,
                    dataBranch.cost_price
                )
            )
            /* step 3 data in branch Offices */
            dataBranch.minimum_stock = this.item.branch_offices[0].minimum_stock
            dataBranch.maximum_stock = this.item.branch_offices[0].maximum_stock
            dataBranch.critical_stock = this.item.branch_offices[0].critical_stock
            //
            branch_office_data[0] = dataBranch
            return branch_office_data
        },
        /**
         *
         */
        async updateInventoryItem(item = this.item, fields) {
            /* this item really can be updated in step 2 */
            this.item.branch_office_data = this.getBranchOfficeDataForStep3()

            /* updating inventory */
            this.item.uom_quantity = this.$refs.InventoryStep.$refs.stepForm.vmodels.uom_quantity
            this.item.wh_unit_of_measurement_id = this.$refs.InventoryStep.$refs.stepForm.vmodels.wh_unit_of_measurement_id
            this.item.have_decimal_quantity = this.$refs.InventoryStep.$refs.stepForm.vmodels.have_decimal_quantity
            this.item.is_repackaged = this.$refs.InventoryStep.$refs.stepForm.vmodels.is_repackaged
            this.item.is_inventoriable = this.$refs.InventoryStep.$refs.stepForm.vmodels.is_inventoriable
            this.item.is_seasonal = this.$refs.InventoryStep.$refs.stepForm.vmodels.is_seasonal
            //this.item.warranty_days = this.item.bra
            /* end updating inventoy  */
            let dataForSending = this.item
            console.log(dataForSending, 'dataForSending')
            let response = await ProductService.updateItem(
                this.item.id,
                dataForSending
            )

            if (this.responseMessage(response)) {
                this.$refs.InventoryStep.$refs.stepForm.editSwitch = false //luego de actualizar se vuelve a switch false
            }
        },
        fetchItem: async function() {
            this.item = await ProductService.fetchById(this.$route.params.id)
            this.gFields[4].options.data = await SubfamilyService.fetchAllSubfamilyByFamilyId(
                this.item.wh_subfamily.wh_family_id
            )
        },
        setGFields(gFields, item) {
            const fields = gFields.map(field => {
                switch (field.field) {
                    case 'wh_family_id':
                        field.value = item.wh_subfamily.wh_family_id
                        break
                    case 'tags':
                        field.value = item.wh_tags
                        break
                    default:
                        field.value = item[field.field]
                        break
                }
                return field
            })
            return fields
        },
        initGfields() {
            this.$data._gFields = this.setGFields(
                this.$data._gFields,
                this.item
            )
        },
        /**
         * @description
         */
        getPropsByFields: function(item, fields) {
            return fields.reduce((obj, field) => {
                obj[field.field] = item[field.field]
                return obj
            }, {})
        },
        /**
         *
         */
        formatBranchOffice(data) {
            data.branch_office_data = []
            data.branch_office_data[0] = data.branch_offices[0]
            data.branch_office_data[0].sale_price = this.setSalesIntoBranchOffice(
                data
            )
            return data
        },
        /**
         * @description
         * set sales price into branches_office_data
         */
        setSalesIntoBranchOffice(data) {
            return data.sale_prices[0].sale_price
        },
        /**
         *
         */
        formatTags(data) {
            data.tags = data.tags.map(tag => {
                if (tag.id) return tag.id
                return tag
            })
            return data
        },
        /**
         *
         */
        setCFields(cFields, item) {
            const fields = cFields.map(field => {
                //
                switch (field.field) {
                    //FIXME: Hardcoded Office
                    case 'cost_price':
                        field.value = parseFloat(
                            item.branch_offices[0].cost_price
                        )
                        break
                    case 'sale_price':
                        field.value = parseInt(item.sale_prices[0].sale_price)
                        break
                    default:
                        field.value = item[field.field]
                        break
                }
                return field
            })
            return fields
        },
        /**
         *
         */
        setIFields(iFields, item) {
            const fields = iFields.map(field => {
                //
                switch (field.field) {
                    case 'critical_stock':
                        field.value = parseInt(
                            item.branch_offices[0].critical_stock
                        )
                        break
                    case 'maximum_stock':
                        field.value = parseInt(
                            item.branch_offices[0].maximum_stock
                        )
                        break
                    case 'minimum_stock':
                        field.value = parseInt(
                            item.branch_offices[0].minimum_stock
                        )
                        break
                    case 'uom_quantity':
                        field.value = item.wh_item.uom_quantity
                        break
                    case 'wh_unit_of_measurement_id':
                        field.value = item.wh_item.wh_unit_of_measurement_id
                        break
                    case 'is_inventoriable':
                        field.value = item.wh_item.is_inventoriable
                        break
                    case 'have_decimal_quantity':
                        field.value = item.wh_item.have_decimal_quantity
                        break
                    default:
                        field.value = item[field.field]
                        break
                }
                return field
                //
            })
            return fields
            //
        },
        getBranchOfficeDataForStep3() {
            let branch_office_data = []
            let dataBranch = {}
            ;(dataBranch.g_branch_office_id = this.officeFormInventarioId), //current branch
                /* step 2 data */
                (dataBranch.cost_price = this.item.branch_offices[0].cost_price)
            dataBranch.sale_price = this.item.sale_prices[0].sale_price
            dataBranch.warranty_days = this.item.branch_offices[0].warranty_days
            dataBranch.gains_margin = parseInt(
                SaleUtils.getMargin(
                    dataBranch.sale_price,
                    dataBranch.cost_price
                )
            )

            /* step 3 data in branch Offices */
            dataBranch.minimum_stock = this.$refs.InventoryStep.$refs.stepForm.vmodels.minimum_stock
            dataBranch.maximum_stock = this.$refs.InventoryStep.$refs.stepForm.vmodels.maximum_stock
            dataBranch.critical_stock = this.$refs.InventoryStep.$refs.stepForm.vmodels.critical_stock
            //
            branch_office_data[0] = dataBranch
            return branch_office_data
        },
        async showSnackbar(
            type,
            title,
            message,
            progress = false,
            time = 3000,
            callback = () => {}
        ) {
            this.resetSnackbarState()
            this.initSnackbar(
                this.fillSnack(type, title, message, progress, time)
            )
            callback()
        },
        async generateUpc() {
            this.showSnackbar('info', 'Generando Código', '', true, null)
            let resp = await UPCService.generateUpc()
            const upc = resp.suggested_code
            this.fillUpcField(upc)
            this.resetSnackbarState()
        },
        fillUpcField(upc) {
            let auxFields = this.$refs.generalStep.$refs.stepForm.vmodels
            let setFields = [...this.gFields]
            //set UPC
            if (setFields[5].value.length > 0)
                setFields[5].value = [upc, setFields[5].value]
            else setFields[5].value = [parseInt(upc)]
            // copy values other fields
            setFields[0].value = auxFields.name
            setFields[1].value = auxFields.alias_name
            setFields[2].value = auxFields.description
            setFields[3].value = auxFields.wh_family_id
            setFields[4].value = auxFields.wh_subfamily_id
            setFields[6].value = auxFields.internal_code
            setFields[7].value = [...auxFields.tags]
            //
            this.gFields = [...setFields]
        },
        listenGs(event) {
            this.setShowButtonUpcCode(event.editable)
        },
        setShowButtonUpcCode(val) {
            this.c_showButtonUpcCode = val
        },
        setComercialForm(office) {
            console.log(office, 'in setComercialForm ')
            let setFields = [...this.cFields]
            setFields[0].value = parseFloat(office.cost_price)
            setFields[1].value = parseInt(office.sale_price)
            this.cFields = [...setFields]
        },
        setInventarioForm(office) {
            let setFields = [...this.iFields]
            setFields[0].value = parseInt(office.minimum_stock)
            setFields[1].value = parseInt(office.maximum_stock)
            setFields[2].value = parseInt(office.critical_stock)
            this.iFields = [...setFields]
        },
        /**
         * verifica en que oficina tenemos valores.
         * si es mayor q uno , asumimos q vienen las 2
         */
        checkValuesForBranchOffice() {
            //
            let branchOffice = this.item.branch_offices
            if (branchOffice.length < 2) {
                this.officeId = branchOffice[0].g_branch_office_id
                this.officeFormInventarioId = branchOffice[0].g_branch_office_id
            }
        },
        /*
         */
        checkSchemaForBranchOffice(schema,idBranchUserLogged) {
            return schema.filter(s=>{
                if(s.g_branch_office_id === idBranchUserLogged) {
                    return s
                }
            })
        },
        /*
         */
        async submitFormSaleDiscount() {
            
            let discountSchema = this.arrayDiscounts.map(arr=>{
                let newObj ={}
                newObj.quantity_discount = arr.quantity
                newObj.percentage_discount = arr.discount
                newObj.unit_price_discount = 0
                return newObj
            })
            //
            let data ={}
            //data.wh_product_id = this.id
            data.g_branch_office_id = this.officeIdSchema
            data.discount_schema = discountSchema
            
            
            priceSchemeProduct(this.$route.params.id, data).then(response=>{
                
                if( response.data.status === 'success'){
                    this.showSnackbar(
                    'success',
                    'Éxito',
                    'Descuento Cantidad creado Exitosamente'
                    )
                    this.step = 4 
                }
                else{
                    this.showSnackbar(
                    'error',
                    'Error',
                    response.data.message
                    )
                }
            })
        },
        /* vuex */
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        
        ...mapActions('WholesaleDiscountModule', {
            resetArrayDiscounts: 'resetArrayDiscounts',
            setInitialArrayDiscounts: 'setInitialArrayDiscounts',
            restartEditingWholesaleDiscount: 'restartEditing',
            setGlobalPercentageDiscount: 'setGlobalPercentageDiscount',
            resetStateWholesaleDiscount: 'resetState',
            setId: 'setId',
            setMaxPriceDiscount: 'setMaxPriceDiscount',
            restartEditing :'restartEditing',
        }),
    },
    watch: {
        officeId(val) {
            let myOffices = [...this.item.branch_offices]
            let salesPrices = [...this.item.sale_prices]
            let office = myOffices.find(
                office => office.g_branch_office_id == val
            )
            let salePrice = salesPrices.find(
                price => price.branch_office_id == val
            )

            if (salePrice) {
                office.sale_price = salePrice.sale_price
                this.setComercialForm(office)
            } else {
                this.showSnackbar(
                    'info',
                    'Sin Precios',
                    'No hay precios asignado para esta sucursal'
                )
            }
        },
        officeFormInventarioId(id) {
            let myOffices = [...this.item.branch_offices]
            let office = myOffices.find(
                office => office.g_branch_office_id == id
            )
            if (office) {
                this.setInventarioForm(office)
            } else {
                this.showSnackbar(
                    'info',
                    'Sin Stocks',
                    'No hay Stocks asignados para esta sucursal'
                )
            }
        },
    },
    components: {
        'loading-dialog': LoadingDialog,
        'commercial-info-step': CommercialInfoStep,
        'manage-whole-sale-discounts' : ManagerWholesaleDiscounts,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    created: async function() {
        this.loading = true
        this.gFields[3].options.data = await FamilyService.fetchAllFamily()
        this.gFields[7].options.data = await TagService.fetchAllTags()
        await this.fetchItem()
        this.gFields = this.setGFields(this.gFields, this.item)
        this.cFields = this.setCFields(this.cFields, this.item)
        this.iFields[3].options.data = await MeasurementUnitService.fetchAll()
        this.iFields = this.setIFields(this.iFields, this.item)
        this.officeList = await BranchOfficeService.fetchAll()
        this.checkValuesForBranchOffice()
        this.setGlobalPercentageDiscount(true)
        // this.addDiscount()
        // this.setId(id)
        let schema = await getPriceSchemeProduct(this.$route.params.id)
        console.log(schema,'schema')
        this.schemaDiscountProducts = [...schema]
        this.officeIdSchema = this.user.hr_employee.g_branch_office_id
        console.log(this.checkSchemaForBranchOffice(schema, this.officeIdSchema),'filtrado')
        this.setInitialArrayDiscounts(schema)
        this.setMaxPriceDiscount(100)
        this.loading = false
    },
    mounted: async function() {
        this.setTitleTopBar('Edición Producto')
        // this.loading = true
        // this.gFields[3].options.data = await FamilyService.fetchAllFamily()
        // this.gFields[7].options.data = await TagService.fetchAllTags()
        // await this.fetchItem()
        // this.gFields = this.setGFields(this.gFields, this.item)
        // this.cFields = this.setCFields(this.cFields, this.item)
        // this.iFields[3].options.data =  await MeasurementUnitService.fetchAll()
        // this.iFields = this.setIFields(this.iFields, this.item)
        // this.officeList = await BranchOfficeService.fetchAll()
        // this.checkValuesForBranchOffice()
        // this.loading = false
        // console.log(this.item,'this item')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_PRODUCT_ITEM')) ctx.$router.push('/')
        })
    },
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>
